import firebase from "../Utils/Firebase";

export const updateProfileImage = (file, uid) => {
  let random = Math.random()
    .toString(36)
    .substring(2);
  let ref = firebase.storage();
  ref = ref.ref().child("images/" + random + ".png");
  var uploadTask = ref.put(file);
  uploadTask.on(
    "state_changed",
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log("Upload is " + progress + "% done");
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED:
          console.log("Upload is paused");
          break;
        case firebase.storage.TaskState.RUNNING:
          console.log("Upload is running");
          break;
        default:
          break;
      }
    },
    function(error) {
      console.log(error);
    },
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        firebase
          .firestore()
          .collection("salons")
          .doc(uid)
          .update({ pictureURL: downloadURL })
          .then((result) => {
            window.location.reload();
          });
      });
    }
  );
};
